(function () {

  var ys = (window.STYLES || []).filter(function (s) { return s.y; }), fab = {}, desc = {};
  ys.forEach(function (s) { var k = String(s.sid); if (window.RVA_FAB && window.RVA_FAB[k]) fab[k] = window.RVA_FAB[k]; if (window.RVA_DESC && window.RVA_DESC[k]) desc[k] = window.RVA_DESC[k]; });
  function keep(name, mine, isArr) {
    var cur;
    function merge(v) {
      if (isArr) { v = Array.isArray(v) ? v : []; mine.forEach(function (k) { if (v.indexOf(k) < 0) v.push(k); }); return v; }
      v = v && typeof v === "object" ? v : {}; Object.keys(mine).forEach(function (k) { if (!(k in v)) v[k] = mine[k]; }); return v;
    }
    cur = merge(window[name]);
    try { Object.defineProperty(window, name, { configurable: true, enumerable: true, get: function () { return cur; }, set: function (v) { cur = merge(v); } }); }
    catch (e) { window[name] = cur; }
  }
  keep("RVA_FAB", fab);
  keep("RVA_DESC", desc);
  keep("RVA_NEW", ys.map(function (s) { return s.b + "|" + s.s; }), true);

  var here = location.pathname.split("/").pop();
  var isYouthPage = ys.some(function (s) { return (s.b + "-" + s.s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") === here; });
  if (isYouthPage && document.querySelector("#rvaCat.rva-style-page")) {
    Array.prototype.forEach.call(document.querySelectorAll('#rvaCat a[href*="#brand="]'), function (a) {
      var h = a.getAttribute("href");
      if (h.indexOf("type=youth") < 0) a.setAttribute("href", h + "&type=youth");
      if (a.classList.contains("rvaAllBrand")) a.innerHTML = a.innerHTML.replace(/ styles/, " youth styles");
    });
  }

  var rm = /(?:^|[#&])r=([A-Za-z0-9_-]+)/.exec(location.hash || "");
  if (rm) {
    var tries = 0, iv = setInterval(function () {
      if (Array.isArray(window.SIZES) && window.SIZES.indexOf("XS") >= 0 && typeof window.loadShared === "function" && window.S) {
        clearInterval(iv);
        try { if (window.loadShared(rm[1])) { if (typeof window.render === "function") window.render(); if (typeof window.saveReq === "function") window.saveReq(); } } catch (e) {}
      } else if (++tries > 300) clearInterval(iv);
    }, 50);
  }
})();